import axios from "axios";

export default class MapboxService {
  geocodeForward = ({ query, limit = 5, country, proximity, types, autocomplete = true }) => {
    return axios({
      method: "GET",
      url: `${process.env.REACT_APP_API}/mapbox/geocode/forward`,
      params: {
        query,
        limit,
        country,
        proximity,
        types,
        autocomplete
      },
      withToken: true,
    });
  };
}